import { Checkbox, Col, Modal, Row } from "antd";
import React, { useEffect } from "react";

import "../../../../assets/style/modalStyle/index.scss";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import { useSelector } from "react-redux";
import { dealSelector } from "../../../../services/selector/index.";
import TranslateText from "../../TranslateText";
import BaseButton from "../../Button/BaseButton";
import { IconPlus, IconXmark } from "../../../../assets/icon";
import ModalAddGroupTime from "../add/ModalAddGroupTime";
import {
  getGroupTime,
  setOpenModalAddGroupTime,
} from "../../../../services/slice/DealSlice";
import { setOpenPUDelete } from "../../../../services/slice/PopUpSlice";
import LabelInput from "../../LabelInput";
import { InputExcelUpload } from "../../Input/InputUploadExcel";
import ModalShowLogUpload from "../ModalShowLogUpload";

const ModalSelectGroupCustomer = ({
  setValueSelectUsed,
  setValueSelectValid,
  valueSelectUsed,
  valueSelectValid,
  valueSelectExpired,
  valueSelectNumberMachine,
  setValueSelectExpired,
  setValueSelectNumberMachine,
  valueSelectListCard,
  setValueSelectListCard,
  setDataPost,
  open,
  setOpen,
}) => {
  const { t } = useTranslation();
  const dealState = useSelector(dealSelector);
  const [type, setType] = useState(1);
  const [dataUsed, setDataUsed] = useState([]);
  const [dataStillValid, setDataStillValid] = useState([]);
  const [dataExpired, setDataExpired] = useState([]);
  const [dataNumberMachine, setDataNumberMachine] = useState([]);
  const [dataExcelCardList, setDataExcelCardList] = useState([]);
  const [typeGroup, setTypeGroup] = useState([]);
  const [openModalErrorUpload, setOpenModalErrorUpload] = useState(false);
  const dispatch = useDispatch();
  const handleCancel = () => {
    setOpen(false);
  };
  const handleCancelModalErrUpload = () => {
    setOpenModalErrorUpload(false);
  };
  useEffect(() => {
    if (dealState?.dataGroupTime?.length) {
      let arrUse = [];
      let arrValid = [];
      let arrExpired = [];
      let arrNumberMachine = [];
      let excelCardList = [];
      dealState.dataGroupTime.map((item) => {
        if (item.typeGroup === 1) {
          arrUse.push(item);
        } else if (item.typeGroup === 2) {
          arrValid.push(item);
        } else if (item.typeGroup === 3) {
          arrExpired.push(item);
        } else if (item.typeGroup === 4) {
          arrNumberMachine.push(item);
        } else {
          excelCardList.push(item);
        }
      });
      setDataExpired(arrExpired);
      setDataNumberMachine(arrNumberMachine);
      setDataUsed(arrUse);
      setDataStillValid(arrValid);
      setDataExcelCardList(excelCardList);
    }
  }, [dealState?.dataGroupTime?.length]);

  const [error, setError] = useState({
    isError: false,
    msg: "",
  });
  useEffect(() => {
    dispatch(getGroupTime());
  }, [dispatch]);
  useEffect(() => {
    if (dealState.callBackRequestGroupTime) {
      dispatch(getGroupTime());
    }
  }, [dispatch, dealState.callBackRequestGroupTime]);

  useEffect(() => {
    if (valueSelectListCard && valueSelectListCard.length > 0) {
      const file = valueSelectListCard[0];
      const fileSize = file.size || file.originFileObj?.size;
      if (fileSize > 20 * 1024 * 1024) {
        setError({
          isError: true,
          msg: "File có kích thước quá lớn. Bạn vui lòng chọn file có kích thước (dung lượng) nhỏ hơn 20MB.",
        });
      } else {
        setError({
          isError: false,
          msg: "",
        });
      }
    }
  }, [valueSelectListCard]);

  const handleSave = () => {
    if (valueSelectListCard.length === 0) {
      setError({
        isError: true,
        msg: "Bạn chưa tải file nào lên hệ thống.",
      });
      return;
    }
    if (
      !valueSelectUsed.length &&
      !valueSelectValid.length &&
      !valueSelectExpired.length &&
      !valueSelectNumberMachine.length
    ) {
      setError({
        isError: true,
        msg: "Bạn chưa chọn nhóm khách hàng",
      });
      return;
    }
    setDataPost((pre) => ({
      ...pre,
      attractGroup: [
        ...valueSelectUsed,
        ...valueSelectValid,
        ...valueSelectExpired,
        ...valueSelectNumberMachine,
        ...valueSelectListCard,
      ],
    }));
    setOpen(false);
  };
  useEffect(() => {
    const groupTypes = [];

    if (valueSelectUsed.length) {
      groupTypes.push(1);
    }
    if (valueSelectValid.length) {
      groupTypes.push(2);
    }
    if (valueSelectExpired.length) {
      groupTypes.push(3);
    }
    if (valueSelectNumberMachine.length) {
      groupTypes.push(4);
    }
    if (valueSelectListCard.length) {
      groupTypes.push(5);
    }
    if (groupTypes.length === 0) {
      setTypeGroup([1]);
    } else {
      setTypeGroup(groupTypes);
    }
  }, []);

  return (
    <>
      {dealState.isOpenModalAddGroupTime ? (
        <ModalAddGroupTime type={type} />
      ) : null}
      {openModalErrorUpload ? (
        <ModalShowLogUpload
          openModal={openModalErrorUpload}
          handleCancel={handleCancelModalErrUpload}
        />
      ) : null}
      <Modal
        maskClosable={false}
        title={<TranslateText text={"Nhóm khách hàng"} />}
        centered
        open={open}
        className="warrperModalSelectGroup"
        width={615}
        footer={[
          <div className="evenSpace">
            <BaseButton
              content={"Hủy bỏ"}
              typeBtn="btnCancel"
              width={90}
              handleClick={handleCancel}
            />
            <BaseButton
              isEnter={true}
              width={90}
              content={"Đồng ý"}
              typeBtn="btnOrange"
              handleClick={handleSave}
            />
          </div>,
        ]}
        onCancel={handleCancel}
      >
        <Checkbox.Group
          style={{
            width: "100%",
          }}
          value={typeGroup}
          onChange={(value) => {
            setError({ isError: false, msg: "" });
            setTypeGroup(value);
            if (!value.includes(1)) setValueSelectUsed([]);
            if (!value.includes(2)) setValueSelectValid([]);
            if (!value.includes(3)) setValueSelectExpired([]);
            if (!value.includes(4)) setValueSelectNumberMachine([]);
          }}
        >
          {/* Danh sách thẻ */}
          <Row>
            <Col span={24}>
              <Checkbox
                value={5}
                checked={
                  typeGroup?.find((item) => item === 5) ||
                  valueSelectUsed.length
                    ? true
                    : false
                }
                className="checkBoxItem"
              >
                <span className="labelSelectGroup">
                  <span
                    style={{
                      fontWeight: "bold",
                      color: "black",
                      fontSize: "16px",
                      width: "140px",
                      marginRight: "0.3rem",
                    }}
                  >
                    Danh sách thẻ:
                  </span>
                  Nhóm khách hàng được phân loại theo mã thẻ trong file danh
                  sách đều sẽ nhận ưu đãi
                </span>
              </Checkbox>
            </Col>
          </Row>
          {typeGroup?.find((item) => item === 5) ? (
            <>
              <Row
                align={"middle"}
                style={{ marginTop: "1.5rem", marginLeft: "1.5rem" }}
              >
                <Col span={4}>
                  <LabelInput text={"Tải tệp tin"} />
                </Col>
                <Col span={20}>
                  <InputExcelUpload
                    className={"upload-excel-code"}
                    fileList={
                      dataExcelCardList.length > 0
                        ? dataExcelCardList
                        : valueSelectListCard
                    }
                    setFileList={(newFile) => {
                      setValueSelectListCard(newFile);
                    }}
                    setError={setError}
                    setOpenModalErrorUpload={setOpenModalErrorUpload}
                  />
                </Col>
              </Row>
              <Row style={{ marginLeft: "1.5rem" }}>
                <Col span={4}></Col>
                <Col span={20} style={{ fontSize: 12, marginTop: 8 }}>
                  Dung lượng file tối đa 20MB. Tải file Excel mẫu{" "}
                  <span
                    style={{
                      color: "#40A9FF",
                      fontWeight: 400,
                      cursor: "pointer",
                      textDecoration: "underline",
                    }}
                  >
                    Tại đây
                  </span>
                  .
                </Col>
              </Row>
            </>
          ) : null}
          {/*  */}

          <Row style={{ marginTop: "2.5rem" }}>
            <Col span={24}>
              <Checkbox
                value={1}
                checked={
                  typeGroup?.find((item) => item === 1) ||
                  valueSelectUsed.length
                    ? true
                    : false
                }
                className="checkBoxItem"
              >
                <span className="labelSelectGroup">
                  <span
                    style={{
                      fontWeight: "bold",
                      color: "black",
                      fontSize: "16px",
                      width: "130px",
                      marginRight: "0.3rem",
                    }}
                  >
                    Đã sử dụng:
                  </span>
                  Tổng thời gian khách hàng đã dùng thẻ bản quyền Bkav Pro (Hiện
                  vẫn đang sử dụng và còn hạn bản quyền):
                </span>
              </Checkbox>
            </Col>
          </Row>
          {typeGroup?.find((item) => item === 1) ? (
            <>
              {" "}
              <Checkbox.Group
                style={{
                  width: "100%",
                }}
                onChange={(value) => {
                  setValueSelectUsed(value);
                }}
                value={valueSelectUsed}
              >
                {dataUsed.map((item) => {
                  return (
                    <Row style={{ marginTop: "1.5rem" }}>
                      <Col span={2}></Col>
                      <Col
                        span={20}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <IconXmark
                          width={16}
                          style={{ marginRight: "1.5rem", cursor: "pointer" }}
                          onClick={() => {
                            dispatch(
                              setOpenPUDelete({
                                stateOpen: true,
                                content: item.name,
                                id: item.id,
                              })
                            );
                          }}
                        />
                        <Checkbox value={item.id}>
                          <span className="labelSelectGroup">
                            <span
                              style={{
                                color: "rgba(0, 0, 0, 0.6)",
                                fontSize: "14px",
                                marginRight: "0.5rem",
                              }}
                            >
                              {item.name}
                            </span>
                          </span>
                        </Checkbox>
                      </Col>
                    </Row>
                  );
                })}
              </Checkbox.Group>
              <Row>
                <Col span={2}></Col>
                <Col span={20}>
                  <div
                    className="btnAddGroupTime"
                    onClick={() => {
                      setType(1);
                      dispatch(setOpenModalAddGroupTime(true));
                    }}
                  >
                    <span className="iconAddGroup">
                      <IconPlus width={11} height={11} />
                    </span>{" "}
                    Thêm phương án
                  </div>
                </Col>
              </Row>
            </>
          ) : null}

          <Row style={{ marginTop: "2.5rem" }}>
            <Col span={24}>
              <Checkbox value={2}>
                <span className="labelSelectGroup">
                  <span
                    style={{
                      color: "black",
                      fontSize: "16px",
                      marginRight: "0.5rem",
                      fontWeight: "bold",
                    }}
                  >
                    Còn hạn:
                  </span>{" "}
                  Nhóm khách hàng đang sử dụng thẻ còn hạn:
                </span>
              </Checkbox>
            </Col>
          </Row>
          <Row style={{ marginTop: "1.5rem" }}>
            <Col span={1}></Col>
            <Col span={24}>
              {typeGroup?.find((item) => item === 2) ? (
                <>
                  <Checkbox.Group
                    style={{
                      width: "100%",
                    }}
                    onChange={(value) => {
                      setValueSelectValid(value);
                    }}
                    value={valueSelectValid}
                  >
                    {dataStillValid?.map((item) => {
                      return (
                        <Row style={{ marginTop: "1.5rem" }}>
                          <Col span={2}></Col>
                          <Col
                            span={20}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <IconXmark
                              width={16}
                              style={{
                                marginRight: "1.5rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                dispatch(
                                  setOpenPUDelete({
                                    stateOpen: true,
                                    content: item.name,
                                    id: item.id,
                                  })
                                );
                              }}
                            />
                            <Checkbox value={item.id}>
                              <span className="labelSelectGroup">
                                <span
                                  style={{
                                    color: "black",
                                    fontSize: "16px",
                                    marginRight: "0.5rem",
                                  }}
                                >
                                  {item.name}
                                </span>{" "}
                              </span>
                            </Checkbox>
                          </Col>
                        </Row>
                      );
                    })}
                  </Checkbox.Group>
                  <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                      <div
                        className="btnAddGroupTime"
                        onClick={() => {
                          setType(2);
                          dispatch(setOpenModalAddGroupTime(true));
                        }}
                      >
                        <span className="iconAddGroup">
                          <IconPlus width={11} height={11} />
                        </span>{" "}
                        Thêm phương án
                      </div>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Col>
          </Row>
          <Row style={{ marginTop: "2.5rem" }}>
            <Col span={24}>
              <Checkbox value={3}>
                <span className="labelSelectGroup">
                  <span
                    style={{
                      color: "black",
                      fontSize: "16px",
                      marginRight: "0.5rem",
                      fontWeight: "bold",
                    }}
                  >
                    Hết hạn:
                  </span>{" "}
                  Nhóm khách hàng đang sử dụng thẻ còn hạn:
                </span>
              </Checkbox>
            </Col>
          </Row>
          <Row style={{ marginTop: "1.5rem" }}>
            <Col span={1}></Col>
            <Col span={24}>
              {typeGroup?.find((item) => item === 3) ? (
                <>
                  <Checkbox.Group
                    style={{
                      width: "100%",
                    }}
                    onChange={(value) => {
                      setValueSelectExpired(value);
                    }}
                    value={valueSelectExpired}
                  >
                    {dataExpired?.map((item) => {
                      return (
                        <Row style={{ marginTop: "1.5rem" }}>
                          <Col span={2}></Col>
                          <Col
                            span={20}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <IconXmark
                              width={16}
                              style={{
                                marginRight: "1.5rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                dispatch(
                                  setOpenPUDelete({
                                    stateOpen: true,
                                    content: item.name,
                                    id: item.id,
                                  })
                                );
                              }}
                            />
                            <Checkbox value={item.id}>
                              <span className="labelSelectGroup">
                                <span
                                  style={{
                                    color: "black",
                                    fontSize: "16px",
                                    marginRight: "0.5rem",
                                  }}
                                >
                                  {item.name}
                                </span>{" "}
                              </span>
                            </Checkbox>
                          </Col>
                        </Row>
                      );
                    })}
                  </Checkbox.Group>
                  <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                      <div
                        className="btnAddGroupTime"
                        onClick={() => {
                          setType(3);
                          dispatch(setOpenModalAddGroupTime(true));
                        }}
                      >
                        <span className="iconAddGroup">
                          <IconPlus width={11} height={11} />
                        </span>{" "}
                        Thêm phương án
                      </div>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Col>
          </Row>
          <Row style={{ marginTop: "2.5rem" }}>
            <Col span={24}>
              <Checkbox value={4}>
                <span className="labelSelectGroup">
                  <span
                    style={{
                      color: "black",
                      fontSize: "16px",
                      marginRight: "0.5rem",
                      fontWeight: "bold",
                    }}
                  >
                    Số máy khách hàng sử dụng:
                  </span>{" "}
                  Nhóm khách hàng đang sử dụng thẻ còn hạn:
                </span>
              </Checkbox>
            </Col>
          </Row>
          <Row style={{ marginTop: "1.5rem" }}>
            <Col span={1}></Col>
            <Col span={24}>
              {typeGroup?.find((item) => item === 4) ? (
                <>
                  <Checkbox.Group
                    style={{
                      width: "100%",
                    }}
                    onChange={(value) => {
                      setValueSelectNumberMachine(value);
                    }}
                    value={valueSelectNumberMachine}
                  >
                    {dataNumberMachine?.map((item) => {
                      return (
                        <Row style={{ marginTop: "1.5rem" }}>
                          <Col span={2}></Col>
                          <Col
                            span={20}
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <IconXmark
                              width={16}
                              style={{
                                marginRight: "1.5rem",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                dispatch(
                                  setOpenPUDelete({
                                    stateOpen: true,
                                    content: item.name,
                                    id: item.id,
                                  })
                                );
                              }}
                            />
                            <Checkbox value={item.id}>
                              <span className="labelSelectGroup">
                                <span
                                  style={{
                                    color: "black",
                                    fontSize: "16px",
                                    marginRight: "0.5rem",
                                  }}
                                >
                                  {item.name}
                                </span>{" "}
                              </span>
                            </Checkbox>
                          </Col>
                        </Row>
                      );
                    })}
                  </Checkbox.Group>
                  <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                      <div
                        className="btnAddGroupTime"
                        onClick={() => {
                          setType(4);
                          dispatch(setOpenModalAddGroupTime(true));
                        }}
                      >
                        <span className="iconAddGroup">
                          <IconPlus width={11} height={11} />
                        </span>{" "}
                        Thêm phương án
                      </div>
                    </Col>
                  </Row>
                </>
              ) : null}
            </Col>
          </Row>
        </Checkbox.Group>
        {error.isError ? <small className="msg">{t(error.msg)}</small> : null}
      </Modal>
    </>
  );
};

export default ModalSelectGroupCustomer;
